(function ($) {
    $.fn.displayselect = function () {
        return this.each(function () {
            var myDisplayselect = $(this);
            $(myDisplayselect).bind('change', function (event) {
                var value = $(this).val();
                var id = $(this).attr('id');
                id = id.replace(/([ #;?&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
                var $item = $('[data-displayselect-parent=' + id + ']');
                $item.css('display', 'none');
                $.each($item, function (index, item) {
                    datas = $(item).data('displayselect-values');
                    for (var i in datas)
                        if (datas[i] == value || new RegExp(datas[i]).test(value)) {
                            $(item).css('display', 'block');
                        }
                });
            }).change();

            return myDisplayselect;
        });

    };

}(jQuery));
